export default function unitEmptyValue() {
    return {
        component: undefined,
        payload: {},
    }
}
